(function () {
  var msgs = window.bmAnnouncementMessages || [];
  var idx = 0;
  var el = document.getElementById('bm-announcement-text');
  if (!el || msgs.length < 2) return;

  function show(i) {
    el.textContent = msgs[i];
  }

  document.querySelectorAll('.bm-announcement__arrow--prev').forEach(function (btn) {
    btn.addEventListener('click', function () {
      idx = (idx - 1 + msgs.length) % msgs.length;
      show(idx);
    });
  });

  document.querySelectorAll('.bm-announcement__arrow--next').forEach(function (btn) {
    btn.addEventListener('click', function () {
      idx = (idx + 1) % msgs.length;
      show(idx);
    });
  });
})();
